import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ComponentRef,
  ElementRef,
  Input,
  Type,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {CdkDrag} from '@angular/cdk/drag-drop';

@Component({
    selector: 'app-window',
    templateUrl: './window.component.html',
    styleUrls: ['./window.component.scss'],
    standalone: false
})
export class WindowComponent implements AfterViewInit {
  @ViewChild('dynamicContainer', {read: ViewContainerRef, static: true})
  container!: ViewContainerRef;

  @ViewChild('dragBox', {read: ElementRef}) dragBox!: ElementRef;
  @ViewChild('dragRef', {read: CdkDrag}) drag!: CdkDrag;

  @Input() window!: {component: Type<any>; [key: string]: any};

  visibility = 'hidden';

  constructor(private cdr: ChangeDetectorRef) {
  }

  ngAfterViewInit(): void {
    this.renderComponent(this.window);

    // Центрирование окна
    setTimeout(() => {
      const el = this.dragBox.nativeElement as HTMLElement;
      const width = el.offsetWidth;
      const height = el.offsetHeight;

      const x = (window.innerWidth - width) / 2;
      const y = (window.innerHeight - height) / 2;

      this.drag._dragRef.setFreeDragPosition({x, y});

      this.cdr.markForCheck();
      this.visibility = 'visible';
    });
  }

  renderComponent(window: any) {
    this.container.clear();
    const compRef: ComponentRef<any> = this.container.createComponent(window.component);
    compRef.instance.window = window;
  }
}
